import { connect,no_render} from 'core'
import * as selectors from 'selectors';
import PMContent from 'comp/middle/pm_content';

const mapToProps = state => {
  const selected = selectors.getSelectedPM()
  const tmp_pm = state.ui.tmp_pm


  if(!selected && !tmp_pm) {
    return no_render
  }
  return {selected,tmp_pm,jumping:state.ui.jump_to_conv}
};


export default connect(PMContent,mapToProps);



// WEBPACK FOOTER //
// ./src/containers/middle/PMContent.js